export default class FileUploadInput {
    constructor(obj) {
        this.stationType = obj.stationType
        this.stationId = obj.stationId
        this.path = obj.path
        this.name = obj.name
        this.content = obj.content
    }
}